import { Component, Inject, OnInit } from '@angular/core';
import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { Router } from '@angular/router';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators, FormGroupDirective } from '@angular/forms';
import { ApiService } from '@services/api.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LocalizationService } from '@services/localization.service';

@Component({
  selector: 'consent-screen-dialog',
  templateUrl: '../sharedTemplates/consent-screen-dialog.component.html',
})
export class ConsentScreenDialog implements OnInit {
  consentScreenForm: UntypedFormGroup;

  constructor(
    private _FormBuilder: UntypedFormBuilder,
    private _ApiService: ApiService,
    public dialogRef: MatDialogRef<ConsentScreenDialog>,
    public dialog: MatDialog,
    private _UiHelper: UiHelper,
    public _UserHelper: UserHelper,
    public _LocalizationService: LocalizationService,

    @Inject(MAT_DIALOG_DATA) public data: ConsentScreenDialog
  ) {
    this.consentScreenForm = _FormBuilder.group({
      terms_conditions: new UntypedFormControl({ value: false, disabled: false }, [Validators.requiredTrue]),
      privacy: new UntypedFormControl({ value: false, disabled: false }, [Validators.requiredTrue]),
    });
  }

  ngOnInit() {
    if (this._UiHelper.currentRoute.indexOf('article') > -1 || this._UiHelper.currentRoute.indexOf('banner') > -1) {
      this.dialogRef.close();
    }
  }

  acceptConsent() {
    // this._UiHelper.b3000SetBottomDialogState('close');
    this._ApiService.getProcCustomerContract(this.consentScreenForm.valid).then(x => {
      if (x[0].resultcode == 104) {
        this.dialogRef.close();
      }
    });
  }
}
